"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportShort = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../../i18n");
var store_1 = require("../../../store");
var DataGrid_1 = require("../components/DataGrid");
var ImageWithTitle_1 = require("../components/ImageWithTitle");
var SplitView_1 = require("../components/SplitView");
var TitleBar_1 = require("../components/TitleBar");
var DataExtractor_1 = require("../DataExtractor");
var pdfTheme_1 = require("../pdfTheme");
var ReportHelpers_1 = require("../ReportHelpers");
var ReportBase_1 = require("./ReportBase");
var ReportShort = /** @class */ (function (_super) {
    tslib_1.__extends(ReportShort, _super);
    function ReportShort(poles) {
        return _super.call(this, poles) || this;
    }
    ReportShort.prototype.buildPDF = function () {
        var _this = this;
        var singleColumnWidth = (pdfTheme_1.pdfTheme.page.width - SplitView_1.SPLIT_VIEW_COLUMN_GAP) / 2;
        this.poles.forEach(function (pole, i) {
            var job = store_1.AppStore.Tag.get(pole.jobId);
            var fullImages = [];
            var fieldNodes = [];
            var tagArr = [];
            var leftPanel = [];
            var rightPanel = [];
            _this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, _this.poles.length, i === 0 ? 'none' : 'before'));
            rightPanel.push(new DataGrid_1.DataGrid(tagArr, 2));
            // Data grid of items outside of sub forms
            pole.forEachField(function (field) {
                if (field.parent.parent == null) {
                    if (field.hasValue() &&
                        field.schema.type !== core_api_1.IkeFieldType.FORM &&
                        field.schema.type !== core_api_1.IkeFieldType.IMAGE &&
                        field.schema.type !== core_api_1.IkeFieldType.TRUE_SIZE) {
                        var extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(field);
                        tagArr.push([extractedValue.title, extractedValue.value]);
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldSubForm) {
                        fieldNodes.push.apply(fieldNodes, (0, ReportHelpers_1.extractSubforms)(pole, field, _this.images, 2));
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                        var captures = field.getCaptures();
                        captures.forEach(function (capture) {
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                    var imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                    _this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                    fullImages.push([field.schema.displayName, imageReferenceString]);
                                }
                            }
                        });
                    }
                }
            });
            if (fullImages[0]) {
                leftPanel.push(new ImageWithTitle_1.ImageWithTitle(fullImages[0][0], { reference: fullImages[0][1] }, { width: singleColumnWidth }));
            }
            fieldNodes.forEach(function (fieldNode, j) {
                if (j % 2 === 0) {
                    leftPanel.push(fieldNode);
                }
                else {
                    rightPanel.push(fieldNode);
                }
            });
            _this.nodes.push(new SplitView_1.SplitView(leftPanel, rightPanel));
        });
    };
    return ReportShort;
}(ReportBase_1.ReportBase));
exports.ReportShort = ReportShort;
//# sourceMappingURL=ReportShort.js.map